import React, { useState, useMemo, useEffect } from 'react'
import PrimaryModal from '../../UI/Modal/PrimaryModal'
import { getAllGithubIntegration } from '../../../utils/APIs';
import Loader from '../../UI/Loader/Loader';
import { toast } from 'react-toastify';
import { useUserContext } from '../../../contexts/UserContext';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import AgGridWrapper from '../../UI/AgGrid';

const GithubIntegrationModal = ({handleClose}) => {

    const [loading, setLoading] = useState(false);
    const [githubData, setGithubData] = useState([]);
    const [selectedItem, setSelectedItem] = useState();
    const [gridApi, setGridApi] = useState(null);

    const { userData, updateDefaultGithub } = useUserContext();
    const { content } = useContentfulContext();

    useEffect(() => {
        getGithubIntegrationDataHandler()
    }, [])

    const getGithubIntegrationDataHandler = async () => {
        try {
            setLoading(true);
            const githubIntegration = await getAllGithubIntegration(userData.token, userData.selectedOrganization.org_token);
            const updated = githubIntegration.data.map((x) => ({
                ...x,
                default: userData.defaultGithub?._id == x._id ? true : false
            }))
            setGithubData(updated);
            // Set the default selected item
            const defaultItem = updated.find((item) => item.default);
            if (defaultItem) setSelectedItem(defaultItem);
        } catch (error) {
            toast.error(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    };

    const handleRowSelected = (event) => {
        const selectedRow = event.data;
        if (selectedItem?._id !== selectedRow._id) {
            setSelectedItem(selectedRow);
            toast.success(content.GLOBAL_SELECTOR_CONTENT.github.success_msg);
            updateDefaultGithub(selectedRow);
        }
    };

    const CheckboxRenderer = (params) => {
        const isChecked = selectedItem?._id === params.data._id;
        return (
            <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleRowSelected(params)}
                className="cursor-pointer rounded-lg w-4 h-4"
            />
        );
    };

    const colDefs= [
        {
            headerName: "",
            field: "checkbox",
            cellRenderer: CheckboxRenderer,
            suppressMovable: true,
        },
        {   headerName: content.GLOBAL_SELECTOR_CONTENT.github.table.name, 
            field: "name", 
            cellRenderer: ({ data }) => (
                <button className='text-center block cursor-pointer text-primary'>{data.name}</button>
            ),
            filter: true,
            sortable: true,
            suppressMovable: true,
            resizable: false
        },
        { 
            headerName: content.GLOBAL_SELECTOR_CONTENT.github.table.repo_name,
            field: "repo_name",
            resizable: false,
            suppressMovable: true,
        },
    ];

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitGridWidth",
          defaultMinWidth: 40,
          columnLimits: [
            {
                colId: "checkbox",
                minWidth: 40,
            },
            {
                colId: "integration_name",
                minWidth: 300,
            },
            {
                colId: "products",
                minWidth: 350,
            },
          ],
        };
    }, []);

    const onFirstDataRendered = (params) => {
        if (githubData.length > 0) {
            const defaultRow = githubData.find((row) => row.default);
            if (defaultRow) {
                setSelectedItem(defaultRow);
            }
        }
    };

    const onFilterTextBoxChanged = (event) => {
        const filterValue = event.target.value.toLowerCase();
        gridApi.setFilterModel({
            integration_name: { type: 'contains', filter: filterValue }
        });
    };

    return (
        <PrimaryModal
            title={content.GLOBAL_SELECTOR_CONTENT.github.title}
            hideModal={() => selectedItem && handleClose()}
            widthClass="max-w-5xl"
        >
            {loading && <Loader />}
            <div className="p-7 pt-1 space-y-6">
                <p>{content.GLOBAL_SELECTOR_CONTENT.github.description}</p>
                <div className='flex justify-between items-center'>
                    <input
                        type="text"
                        className='block px-2.5 py-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none max-w-64'
                        placeholder="Search by name"
                        onChange={onFilterTextBoxChanged}
                    />
                </div>
                <div className={"ag-theme-quartz"} style={{ height: "100%", width: "100%" }} >
                    <AgGridWrapper
                        tableId="global-selector-github-integration-table"
                        rowData={githubData}
                        columnDefs={colDefs}
                        autoSizeStrategy={autoSizeStrategy}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        rowSelection="single"
                        suppressRowClickSelection
                        onRowSelected={handleRowSelected}
                    />
                </div>
            </div>
        </PrimaryModal>
    )
}

export default GithubIntegrationModal

